import { BookOpen, Phone, ArrowRight } from "lucide-react";
import { PHONE_DISPLAY, PHONE_HREF } from "@/lib/contact";
import { Header } from "@/components/tps/Header";
import { Footer } from "@/components/tps/Footer";
import { MobileCallBar } from "@/components/tps/MobileCallBar";
import { SoroBlog } from "@/components/tps/SoroBlog";

export const BlogPage = () => {
    return (
        <div className="min-h-screen bg-tp-offwhite text-tp-ink flex flex-col">
            <Header />

            {/* Hero strip */}
            <section
                id="top"
                data-testid="blog-hero"
                className="relative overflow-hidden bg-tp-forest text-white"
            >
                <div
                    className="absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full pointer-events-none"
                    style={{
                        background:
                            "radial-gradient(closest-side, rgba(232,185,35,0.28), rgba(232,185,35,0) 70%)",
                    }}
                />
                <div className="tp-grain absolute inset-0" />
                <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16">
                    <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-3 py-1.5 text-xs uppercase tracking-[0.18em] text-tp-gold">
                        <BookOpen size={13} strokeWidth={2.4} className="text-tp-gold" />
                        Skip bin hire guides &amp; tips
                    </div>
                    <h1 className="mt-4 font-heading text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                        <span className="text-white">The </span>
                        <span className="text-tp-gold">Tipping Point</span>
                        <span className="text-white"> blog</span>
                    </h1>
                    <p className="mt-4 max-w-2xl text-sm md:text-base text-white/90 leading-relaxed">
                        Straight-up guides on skip bin hire in Sydney &mdash; choosing
                        the right size, understanding waste types, permits and kerbside
                        placement, plus tips for keeping your job site tidy from start
                        to finish.
                    </p>
                    <div className="mt-6 flex flex-col sm:flex-row gap-3">
                        <a
                            href={PHONE_HREF}
                            data-testid="blog-hero-call"
                            className="tp-btn-primary h-11 px-5 tp-focus"
                        >
                            <Phone size={16} strokeWidth={2.6} />
                            Call {PHONE_DISPLAY}
                        </a>
                        <a
                            href="/#quote"
                            data-testid="blog-hero-quote"
                            className="tp-btn-outline h-11 px-5 tp-focus"
                        >
                            Get a Free Quote
                            <ArrowRight size={16} strokeWidth={2.4} />
                        </a>
                    </div>
                </div>
                <div className="relative h-3 tp-stripes opacity-90" />
            </section>

            {/* Blog embed */}
            <main className="flex-1 pb-24 md:pb-16">
                <div
                    data-testid="blog-embed-wrapper"
                    className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14"
                >
                    <SoroBlog />

                    {/* Fallback CTA under the embed */}
                    <div className="mt-10 md:mt-14 rounded-2xl bg-tp-forest text-white p-5 md:p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                        <div>
                            <div className="text-xs uppercase tracking-[0.16em] text-tp-gold">
                                Ready to book a bin?
                            </div>
                            <p className="mt-1 font-heading text-xl md:text-2xl">
                                Skip the reading &mdash; call us for a quote in under a minute.
                            </p>
                        </div>
                        <a
                            href={PHONE_HREF}
                            data-testid="blog-footer-call"
                            className="tp-btn-primary text-sm h-11 tp-focus"
                        >
                            <Phone size={16} strokeWidth={2.6} />
                            Call {PHONE_DISPLAY}
                        </a>
                    </div>
                </div>
            </main>

            <Footer />
            <MobileCallBar />
        </div>
    );
};

export default BlogPage;
